import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import CrmLayout from '../../../components/CrmLayout';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import { Button, Empty, Space, Tabs } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ModalAddIndicator from './ModalAddIndicator';
import ModalAddSkill from './ModalAddSkill';
import React from 'react';
import TabPane from 'antd/es/tabs/TabPane';
import ClientIndicator from './ClientIndicator';
import ClientSkill from './ClientSkill';
import _ from 'lodash';
import Graph from './Graph';
import { QUERY_PARENTS } from '../../../graphql/parent';

export function ClientGraph() {

    const { id } = useParams();

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
        },
    });

    const [modalIndicator, setModalIndicator] = React.useState(false);
    const [modalSkill, setModalSkill] = React.useState(false);

    const type = query.data?.usersPermissionsUser?.data?.attributes?.client?.data ? 'child' : 'parent';

    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;
    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;

    const parents = useQuery(QUERY_PARENTS, {
        variables: {
            filters: {
                clients: {
                    id: { eq: client?.id },
                },
            },
        },
        skip: !client || type !== 'child',
    });

    if (!client) {return null}

    let indicators = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    let skills = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    let graph = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;

    // Цели
    if (client.attributes?.indicator?.length > 0) {
        indicators = _.map(client.attributes?.indicator, (item) => {
            return (
                <ClientIndicator
                    key={item.id}
                    client={client}
                    type={type}
                    indicator={item}
                    onUpdate={() => query.refetch()}
                />
            )

        });
    }

    // Навыки
    if (client.attributes?.skill?.length > 0) {
        skills = _.map(client.attributes?.skill, item => {
            return (
                <ClientSkill
                    key={item.id}
                    client={client}
                    type={type}
                    skill={item}
                    onUpdate={() => query.refetch()}
                />
            )

        });
    }

    // График
    if (client.attributes?.indicator?.length > 0 || client.attributes?.skill?.length > 0) {

        let contacts = []
        // личные контакты дитя
        for (const contact of query.data?.usersPermissionsUser?.data?.attributes?.contacts || []) {
            if (contact.data) {
                contacts.push({
                    ...contact,
                    data: {
                        firstName: contact.data.chat.first_name,
                        lastName: contact.data.chat.last_name,
                        username: contact.data.chat.username || contact.value,
                    }
                })
            } else {
                contacts.push({
                    ...contact,
                    data: {
                        firstName: query.data.client.data.attributes.firstName,
                        lastName: query.data.client.data.attributes.lastName,
                        username: null,
                    }
                })
            }
        }
        // контакты всех родителей
        for (const parent of parents.data?.parents?.data || []) {
            for (const contact of parent.attributes?.account?.data?.attributes?.contacts) {
                if (contact.data) {
                    contacts.push({
                        ...contact,
                        data: {
                            firstName: contact.data.chat.first_name,
                            lastName: contact.data.chat.last_name,
                            username: contact.data.chat.username || contact.value,
                        }
                    })
                } else {
                    contacts.push({
                        ...contact,
                        data: {
                            firstName: parent.attributes.firstName,
                            lastName: parent.attributes.lastName,
                            username: null,
                        }
                    })
                }
            }
        }
        // подчищаем все неуникальные
        contacts = _.uniqBy(contacts, 'value');

        graph = <Graph
            clientID={client.id}
            firstName={client.attributes.firstName}
            lastName={client.attributes.lastName}
            indicators={client.attributes.indicator}
            skills={client.attributes.skill}
            contacts={contacts}
        />
    }

    return (
        <CrmLayout>

            <CrmCenteredTitle title={`${title} – Цели, Навыки, Графики`}/>

            <Tabs>
                <TabPane key="indicators" tab={'Цели'}>
                    <Space direction='vertical' size={10} className='block'>
                        {indicators}
                        <Button type={'link'} icon={<PlusOutlined/>} onClick={() => setModalIndicator(true)}>Добавить цель</Button>
                        <ModalAddIndicator isOpen={modalIndicator}
                                           onClose={() => setModalIndicator(false)}
                                           onUpdate={() => query.refetch()}
                                           client={client}
                                           type={type}
                        />
                    </Space>
                </TabPane>

                <TabPane key="skills" tab={'Навыки'}>
                    <Space direction='vertical' size={10} className='block'>
                        {skills}
                        <Button type={'link'} icon={<PlusOutlined/>} onClick={() => setModalSkill(true)}>Добавить
                            навык</Button>
                        <ModalAddSkill isOpen={modalSkill}
                                       onClose={() => setModalSkill(false)}
                                       onUpdate={() => query.refetch()}
                                       client={client}
                                       type={type}
                        />
                    </Space>
                </TabPane>

                <TabPane key="graph" tab={'График'}>
                    {graph}
                </TabPane>
            </Tabs>

        </CrmLayout>
    );
}
